const DrawingMode = {
    'STOP':null,
    'MODE':'polygon',
    'MODES': [{key: 'circle', text: 'circle'},{key: 'polygon', text: 'polygon'},{key: 'rectangle', text: 'rectangle'},{key: 'nangcao', text: 'nangcao'}] 
}

export default DrawingMode
